import React, { Component } from "react";
// import ug from '../assets/ug.svg'
// import circletick from '../assets/circletick.svg'

export default class MessageItem extends Component {
  onClick() {
    this.props.onSelected(this.props.id, null);
  }

  render() {
    return (
      <div
        className="UGItem"
        onClick={this.onClick.bind(this)}
        style={{
          backgroundColor: this.props.selected ? "var(--brown4)" : "white",
          border: this.props.selected
            ? "1px solid var(--brown1)"
            : "1px solid white",
        }}
        dir="auto"
      >
        <div style={{ display: "flex", flexDirection: "row" }}>
          <div>{this.props.name}</div>
        </div>
      </div>
    );
  }
}
